module.exports = __webpack_public_path__ + "media/images/city/022-christ-the-redeemer-b578c2dbea78d696c1ba7d67c34580c3.svg";